<template>
    <div class="form__item" :class="{ 'has-error': !!error }">
        <input
            :type="type"
            :class="'form__input--text'"
            :name="name"
            :id="name + _uid"
            :value="model"
            :placeholder="placeholder"
            @input="onInput"
            @change="onChange"
            :autocomplete="autocomplete"
        />
        <slot></slot>
        <p class="form__item__error" v-show="!!error">
            {{ error }}
        </p>
    </div>
</template>

<script>
import Vue from 'vue';
import { Component, Prop } from 'vue-property-decorator';

@Component
export default class FormInput extends Vue {
    @Prop({ default: 'text' }) type;
    @Prop(String) name;
    @Prop(String) placeholder;
    @Prop(Object) value;
    @Prop(String) autocomplete;

    onInput(event) {
        const newValue = JSON.parse(JSON.stringify(this.value));
        newValue[this.name] = { value: event.target.value };
        this.$emit('input', newValue);
    }

    onChange(event) {
        const newValue = JSON.parse(JSON.stringify(this.value));
        newValue[this.name] = { value: event.target.value };
        this.$emit('change', newValue);
    }

    get inputClass() {
        switch (this.type) {
            case 'checkbox':
                return 'checkbox__cb';
            case 'password':
            case 'text':
            default:
                return 'form__input--text';
        }
    }

    get model() {
        return this.value[this.name] ? this.value[this.name].value : '';
    }

    get error() {
        return this.value[this.name] ? this.value[this.name].error : '';
    }
}
</script>
